module.exports = __webpack_public_path__ + "img/njcb-meets-bg.1a47e0be.png";